import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { API } from '../App';
import { CheckCircle2, Loader2 } from 'lucide-react';

export default function AffiliatePage() {
  const [f, setF] = useState({ full_name: '', email: '', whatsapp: '', social_link: '', country: 'UAE', promotion_plan: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/affiliate/signup`, f);
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to submit');
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2" data-testid="affiliate-title">Become a Daily UAE Jobs Affiliate</h1>
          <p className="text-gray-600">Promote our CV tools and earn 25% commission on every successful paid referral.</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-6 text-center text-sm">
          {[{n:'Pro',p:99},{n:'Career Boost',p:199},{n:'Elite',p:499}].map(x => (
            <Card key={x.n} className="p-3">
              <p className="text-xs text-gray-500">{x.n}</p>
              <p className="font-bold">AED {x.p}</p>
              <p className="text-xs text-[#009639]">You earn AED {Math.round(x.p*0.25)}</p>
            </Card>
          ))}
        </div>

        <Card className="p-6">
          {done ? (
            <div className="text-center py-6" data-testid="affiliate-success">
              <CheckCircle2 className="w-16 h-16 text-[#009639] mx-auto mb-3" />
              <h2 className="text-xl font-bold mb-2">Application Received</h2>
              <p className="text-gray-600">Our team will contact you within 24 hours with your referral code.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3" data-testid="affiliate-form">
              {['full_name','email','whatsapp','country','promotion_plan'].map(k => (
                <div key={k}>
                  <label className="block text-xs font-medium text-gray-700 mb-1 capitalize">{k.replace('_',' ')} *</label>
                  <input required type={k==='email'?'email':'text'} value={f[k]} onChange={e=>set(k,e.target.value)}
                    placeholder={k==='promotion_plan' ? 'How will you promote us?' : ''}
                    className="w-full h-9 rounded-md border border-gray-300 px-3 text-sm" data-testid={`aff-${k}`} />
                </div>
              ))}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Social Media Link (optional)</label>
                <input type="text" value={f.social_link} onChange={e=>set('social_link',e.target.value)}
                  className="w-full h-9 rounded-md border border-gray-300 px-3 text-sm" />
              </div>
              <Button type="submit" disabled={submitting} className="btn-uae-red">
                {submitting ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Submitting...</> : 'Submit Application'}
              </Button>
            </form>
          )}
        </Card>

        <Card className="p-6 mt-6 text-sm text-gray-700">
          <h3 className="font-semibold mb-2">Program Terms</h3>
          <ul className="space-y-1 list-disc pl-5">
            <li>25% commission per verified paid referral</li>
            <li>Commission counted only after payment is verified</li>
            <li>Refunds/cancellations are not commissionable</li>
            <li>Payout is manual (bank transfer or WhatsApp)</li>
            <li>Daily UAE Jobs is a career support platform, not a recruitment agency</li>
          </ul>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
